import { useCallback, useEffect, useState } from 'react';

function useImagePreload(images?: string[]): HTMLImageElement[] {
  const [data, setData] = useState<HTMLImageElement[]>([]);

  const preload = useCallback((src: string) => {
    return new Promise<HTMLImageElement | null>((resolve) => {
      const image = new Image();
      image.onload = () => {
        resolve(image);
      };
      image.onerror = image.onabort = () => {
        resolve(null);
      };
      image.src = src;
    });
  }, []);

  useEffect(() => {
    if (!images || !images?.length) return;

    const preloadAll = async () => {
      const imageList: Promise<HTMLImageElement | null>[] = [];
      images.forEach((image) => {
        imageList.push(preload(image));
      });
      return Promise.all(imageList).then((data) => {
        const filteredData = data.filter(
          (item) => item !== null
        ) as HTMLImageElement[];
        setData(filteredData);
      });
    };
    preloadAll();
  }, [images]);

  return data;
}

export default useImagePreload;
